<div class="row">
    <div class="col-12 order-1 col-sm-12 col-md-12 col-lg-9 order-lg-0">
        <div class="row">
            <div class="col-12">
              <app-box-archive *ngIf="tag" [type]="'tags'" [id]="tag.id"></app-box-archive>
            </div>
        </div>
    </div>

    <div class="col-12 order-0 col-sm-12 col-md-12 col-lg-3 order-lg-1">
        <div class="sidebar">
            <nb-card>
                <nb-card-body>
                    <button  (click)="testpush()" nbButton size="medium" fullWidth status="primary">
                        <nb-icon icon="navigation-2-outline"></nb-icon>Test Push
                    </button>

                    <br />
                    <br />
                    <br />

                    <button (click)="edit()" nbButton size="medium" fullWidth status="primary">
                        <nb-icon icon="edit-outline"></nb-icon>{{'edit' | translate }}
                    </button>

                    <br />
                    <br />
            
                    <button nbButton (click)="location.back()" size="medium" fullWidth status="primary">
                      <nb-icon icon="arrow-back-outline"></nb-icon>{{'back' | translate }}
                    </button>
                </nb-card-body>
            </nb-card>

            <app-box-subscribers *ngIf="tag" [type]="'tag'" [entity]="tag"></app-box-subscribers>

        </div>
    </div>
</div>
